export default "__VITE_PUBLIC_ASSET__081eca60__"